import $ from 'jquery';

$(() => {
  $('.js-close-cookies').on('click', (e) => {
    $('.cookies-panel .wrapper').css('opacity', 0);
    $('.cookies-panel').addClass('hiden');
    e.preventDefault();
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/cookies-panel.js
 **/